// extracted by mini-css-extract-plugin
export var formContainer = "_ks-0";
export var message = "_ks-1";